<template>
<div class="details-component">
  <div class="details-component__header">
    <h1>{{ $t('parking.parking_report') }}</h1>
  </div>
  <div class="details-component__content content">
    <form class="form fixed-form">
      <table class="details-table tenant no-col-padding edit-table fixed-table label-col-wide-150">
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">
            <label for="parking_type" class="form__label">{{ $t('common.parking_type') }}</label>
          </td>
          <td class="details-table__col">
            <el-select name="parking_type"
                       v-model="parkingTypesCode"
                       clearable
                       filterable
                       placeholder=""
                       multiple
            >
              <el-option
                v-for="parking_type in computed_parkingTypes"
                :key="parking_type.id"
                :label="$t(parking_type.name)"
                :value="parking_type.code"
              >
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('startDate')}">
          <td class="details-table__col details-table__col_label">
            <label for="startDate" class="form__label">{{ $t('parking.startTime') }}</label>
          </td>
          <td class="details-table__col">
            <el-date-picker
              v-model="startDate"
              format="dd.MM.yyyy"
              type="date"
              name="startDate"
              :picker-options="startTimeOptions"
            />
          </td>
        </tr>
        <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('endDate')}">
          <td class="details-table__col details-table__col_label">
            <label for="endTime" class="form__label">{{ $t('parking.endTime') }}</label>
          </td>
          <td class="details-table__col">
            <el-date-picker
              v-model="endDate"
              format="dd.MM.yyyy"
              type="date"
              name="endDate"
              :picker-options="endTimeOptions"
            />
          </td>
        </tr>
        <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('tenant')}" v-if="isLandlord()">
          <td class="details-table__col details-table__col_label">
            <label for="tenant" class="form__label">{{ $t('common.tenant') }}</label>
          </td>
          <td class="details-table__col">
            <el-select name="tenant"
                       v-model="tenantIds"
                       placeholder=""
                       clearable
                       multiple
                       filterable
                       ref="tenantSelect"
                       :filter-method="() => { return true; }"
                       :remote="true"
                       :loading="areTenantsLoading"
                       :remote-method="() => { onTenantInput(); }">
              <el-option
                      v-for="tenant in tenants.items"
                      :key="tenant.id"
                      :label="`${tenant.name} - ( ${tenant.address} )`"
                      :value="tenant.id">
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('product')}">
          <td class="details-table__col details-table__col_label">
            <label for="product" class="form__label">{{ $t('common.product') }}</label>
          </td>
          <td class="details-table__col">
            <el-select name="product"
                       v-model="productId"
                       clearable
                       filterable
                       placeholder=""
                       v-if="products.items && products.items.length > 0">
              <el-option
                      v-for="product in products.items"
                      :key="product.id"
                      :label="product.name"
                      :value="product.id">
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">
            <label for="zone" class="form__label">{{ $t('common.zone') }}</label>
          </td>
          <td class="details-table__col">
            <el-select name="zone"
                       v-model="zoneCode"
                       clearable
                       filterable
                       placeholder=""
                       multiple
                       v-if="zones.data && zones.data.length > 0">
              <el-option
                      v-for="zone in zones.data"
                      :key="zone.id"
                      :label="zone.code"
                      :value="zone.code">
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('vehicle_reg')}">
          <td class="details-table__col details-table__col_label">
            <label for="vehicle_reg" class="form__label">{{ $t('common.vehicle_reg') }}</label>
          </td>
          <td class="details-table__col">
            <input type="text" class="form__input" name="vehicleReg" id="vehicleReg" v-model.trim="form.vehicleReg"/>
          </td>
        </tr>
        <tr class="details-table__row" v-if="user.paymentModuleEnabled && isLandlord()">
          <td class="details-table__col details-table__col_label">
            <label for="cost_center" class="form__label">{{ $t('parking.cost_center') }}</label>
          </td>
          <td class="details-table__col">
            <input type="text" class="form__input" name="cost_center" id="cost_center" v-model="form.costCenter"/>
          </td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">
            <label for="column-separator" class="form__label">{{ $t('parking.decimal_separator') }}</label>
          </td>
          <td class="details-table__col">
            <el-select name="decimal-separator"
                       v-model="decimalSeparator"
                       clearable
                       placeholder=""
                       @change="resetColumnSeparator()">
              <el-option
                      v-for="separator in decimalSeparators"
                      :key="separator.value"
                      :label="separator.label"
                      :value="separator.value">
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">
            <label for="column-separator" class="form__label">{{ $t('parking.column_separator') }}</label>
          </td>
          <td class="details-table__col">
            <el-select name="column-separator"
                       v-model="columnSeparator"
                       clearable
                       placeholder=""
                       @change="updateLocalStorage()">
              <el-option
                      v-for="separator in columnSeparators"
                      :key="separator.value"
                      :label="separator.label"
                      :value="separator.value">
              </el-option>
            </el-select>
          </td>
        </tr>
      </table>
      <div class="form__buttons buttonset">
        <router-link :to="{ name: 'parkings' }" class="buttonset__button btn btn--secondary">
            {{ $t('common.discard') }}
        </router-link>
        <div class="buttonset__button btn btn--main">
          <ReportDownloadDropdown @reportFormat="startDownload"/>
        </div>
      </div>
    </form>
  </div>
  <WarningModal v-if="showWarningModal" @close="closeWarningModal">
    <h1 slot="header">{{ $t('common.warning') }}</h1>
    <p slot="body">{{ warningText }}</p>
  </WarningModal>
</div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';
import moment from 'moment';
import {getAdminPath} from '../../store/store-helpers';
import WarningModal from "../common/WarningModal";
import ReportDownloadDropdown from "./ReportDownloadDropdown.vue";

export default {
  components:{
    WarningModal,
    ReportDownloadDropdown
  },
  computed: {
    ...mapGetters({
      products: 'landlord/products/products',
      zones: 'landlord/zones/zones',
      user: 'user/user/user',
      parkings: 'landlord/parkings/parkings',
      tenants: 'landlord/tenants/tenants',
    }),
    computed_parkingTypes() {
      return this.parkingTypes.filter(item =>
        !!(item.onlyLandlord === false || this.isLandlord() || this.isSuperAdmin()),
      );
    },
  },
  created() {
    if (localStorage.getItem('report-generator')) {
      const reportGeneratorParams = JSON.parse(localStorage.getItem('report-generator'));
      this.decimalSeparator = reportGeneratorParams.decimalSeparator;
      this.columnSeparator = reportGeneratorParams.columnSeparator;
    }
    this.$store.commit(`landlord/parkings/${mTypes.CLEAR_STATE}`);
    if (this.isLandlord()) {
      this.reportFieldNames.splice(6, 0, 'Rev. Share Landlord');
      this.reportFields.splice(6, 0, 'priceLL');
      this.totalFields.splice(6, 0, 'totalLL');
      this.reportFieldNames = [
        'Tenant ID',
        'Tenant Name',
        'Tenant Legal Address',
        'Tenant Reg. Code',
        'Tenant VAT',
        'Tenant Contact Person',
        'Contact Person Phone',
        'Contact Person Email',
      ].concat(this.reportFieldNames);
      this.reportFields = [
        'tenantID',
        'tenantName',
        'tenantLegalAddress',
        'tenantRegCode',
        'tenantVAT',
        'tenantContactPerson',
        'tenantPhone',
        'tenantEmail',
      ].concat(this.reportFields);
      this.totalFields = [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      ].concat(this.totalFields);

      // Set default values for start and end time
      const lastMonth = moment().subtract(1, 'months')
      this.startDate = lastMonth.startOf('month').format('YYYY-MM-DD');
      this.endDate = lastMonth.endOf('month').format('YYYY-MM-DD');
    }
    if (this.user.data.selectedRole.isSuperadmin === true) {
      this.reportFieldNames = [
        'Landlord ID',
        'Landlord Name',
      ].concat(this.reportFieldNames);
      this.reportFields = [
        'landlordID',
        'landlordName',
      ].concat(this.reportFields);
      this.totalFields = [
        '',
        '',
      ].concat(this.totalFields);
    }
    this.$store.commit(`landlord/tenants/${mTypes.CLEAR_STATE}`);
    this.fetchTenantProducts();
    this.fetchZones();
  },
  data() {
    return {
      showWarningModal: false,
      warningText: null,
      form: {},
      decimalSeparator: '.',
      columnSeparator: ',',
      decimalSeparators: [
        {
          value: '.',
          label: '.',
        },
        {
          value: ',',
          label: ',',
        },
      ],
      columnSeparators: [
        {
          value: ',',
          label: ',',
        },
        {
          value: ';',
          label: ';',
        },
      ],
      reportFieldNames: [
        'Parking ID',
        'Parking Start Time',
        'Parking End Time',
        'Pack',
        'Vehicle Reg. Num',
        'Zone Codes',
        'Price',
        'Rev. Share Tenant',
        'comment',
        'Created By',
      ],
      reportFields: [
        'id',
        'startTime',
        'endTime',
        'product',
        'vehicleReg',
        'zone_codes',
        'price',
        'priceTN',
        'comment',
        'created_by',
      ],
      totalFields: [
        '',
        '',
        '',
        '',
        '',
        '',
        'total',
        'totalTN',
        '',
      ],
      startDate: null,
      endDate: null,
      productId: null,
      tenantIds: [],
      zoneCode: [],
      parkingTypesCode: [],
      forceSearchTenantsTimeout: null,
      areTenantsLoading: false,
      startTimeOptions: {
        disabledDate: (date) => {
          return moment(date).isAfter(moment(), 'day');
        },
        firstDayOfWeek: 1,
      },
      endTimeOptions: {
        disabledDate: (date) => {
          if (this.startDate) {
            return moment(this.startDate).isAfter(moment(date), 'day');
          }
          return false;
        },
        firstDayOfWeek: 1,
      },
      parkingTypes: [
        {
          id: 1,
          name: 'common.permit_easy_parking',
          code: 'permit_easy_parking',
          onlyLandlord: false,
        },
        {
          id: 2,
          name: 'common.free_easy_parking',
          code: 'free_easy_parking',
          onlyLandlord: true,
        },
        {
          id: 3,
          name: 'common.guest_parking',
          code: 'guest_parking',
          onlyLandlord: false,
        },
        {
          id: 4,
          name: 'common.paid_easy_parking',
          code: 'paid_easy_parking',
          onlyLandlord: true,
        },
      ],
    };
  },
  methods: {
    closeWarningModal() {
      this.showWarningModal = false
      this.warningText = null
    },
    startDownload(reportFormat) {
      if (!this.startDate || !this.endDate) {
        this.warningText = 'Start time and/or End time not defined'
        this.showWarningModal = true
      } else {
        window.open(this.getDownloadUrl(reportFormat), '_blank')
      }
    },
    getDownloadUrl(reportFormat) {
      let url = `${getAdminPath(this.user, 'export')}/parkings/`;
      url += `?token=${localStorage.getItem('id_token')}`;

      if (this.startDate) {
        url += `&startDate=${moment(this.startDate).format('YYYY-MM-DD')}`;
      }

      if (this.endDate) {
        url += `&endDate=${moment(this.endDate).format('YYYY-MM-DD')}`;
      }

      if (this.tenantIds.length) {
        for (let i = 0; i < this.tenantIds.length; i += 1) {
          url += `&tenantIds[]=${this.tenantIds[i]}`;
        }
      }

      if (this.productId) {
        url += `&productId=${this.productId}`;
      }

      if (this.zoneCode.length) {
        for (let i = 0; i < this.zoneCode.length; i += 1) {
          url += `&zoneCode[]=${this.zoneCode[i]}`;
        }
      }

      if (this.parkingTypesCode.length) {
        for (let i = 0; i < this.parkingTypesCode.length; i += 1) {
          url += `&parking_types[]=${this.parkingTypesCode[i]}`;
        }
      }

      if (this.form.vehicleReg) {
        url += `&vehicleReg=${this.form.vehicleReg}`;
      }
      if (this.form.vehicleReg && this.isLandlord() && this.user.paymentModuleEnabled) {
        url += `&cost_center=${this.form.costCenter}`;
      }
      if (this.decimalSeparator) {
        url += `&decSeparator=${this.decimalSeparator}`;
      }

      if (this.columnSeparator) {
        url += `&columnSeparator=${this.columnSeparator}`;
      }

      return url + `&format=${reportFormat}`;
    },
    fetchTenantProducts() {
      if (this.user) {
        if (this.isLandlord()) {
          this.$store.dispatch('landlord/products/fetch', { user: this.user, type: 'guestParking', limit: 200 });
        } else if (this.isTenant() && this.user.data) {
          this.$store.dispatch('landlord/products/fetchTenantProducts', { user: this.user, type: 'guestParking', limit: 200 });
        } else {
          this.products.items = {};
        }
      }
    },
    onTenantInput() {
      if (this.$refs.tenantSelect && this.$refs.tenantSelect.$refs.input && this.$refs.tenantSelect.$refs.input.value === '') {
        this.$store.commit(`landlord/tenants/${mTypes.CLEAR_STATE}`);
        return true;
      }
      this.areTenantsLoading = true;
      const myTimerPromise = new Promise((resolve, reject) => {
        clearTimeout(this.forceSearchTenantsTimeout);
        this.forceSearchTenantsTimeout = setTimeout(() => {
          this.fetchTenants(resolve, reject);
        }, 300);
      });
      Promise.all([myTimerPromise]).then(() => {
        this.areTenantsLoading = false;
      });
      return true;
    },
    fetchTenants(resolve, reject) {
      if (this.$refs.tenantSelect && this.$refs.tenantSelect.$refs.input) {
        const q = this.$refs.tenantSelect.$refs.input.value;
        this.$store.dispatch('landlord/tenants/fetch', { keyword: q, user: this.user, limit: 200, withTrash: true })
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          });
      }
    },
    fetchZones() {
      this.$store.dispatch('landlord/zones/list', { user: this.user });
    },
    resetColumnSeparator() {
      if (!this.storedColumnSeparators) {
        this.storedColumnSeparators = this.columnSeparators;
      }
      this.columnSeparators = [];
      this.storedColumnSeparators.forEach((item) => {
        if (item.value !== this.decimalSeparator) {
          this.columnSeparators.push(item);
        }
      });
      this.columnSeparator = this.columnSeparators[0].value;
      this.updateLocalStorage();
    },
    updateLocalStorage() {
      localStorage.setItem('report-generator', JSON.stringify(
        {
          decimalSeparator: this.decimalSeparator,
          columnSeparator: this.columnSeparator,
        },
      ));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/parkings/ReportParkingsForm.vue